import React, { useState } from 'react';
import GalleryGrid from '../components/gallery/GalleryGrid';
import ImageModal from '../components/gallery/ImageModal';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { galleryImages } from '../data/galleryData';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [titleRef, isTitleVisible] = useIntersectionObserver();

  const handleNext = () => {
    if (!selectedImage) return;
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setSelectedImage(galleryImages[nextIndex]);
  };

  const handlePrevious = () => {
    if (!selectedImage) return;
    const currentIndex = galleryImages.findIndex(img => img.id === selectedImage.id);
    const previousIndex = currentIndex === 0 ? galleryImages.length - 1 : currentIndex - 1;
    setSelectedImage(galleryImages[previousIndex]);
  };

  return (
    <div className="relative min-h-screen pt-20">
      {/* Tło */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/50 z-10" />
        <img
          src="https://images.unsplash.com/photo-1672840997353-4579d5d6a7d5?q=80&w=1932&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover object-center fixed"
          aria-hidden="true"
        />
      </div>

      {/* Zawartość */}
      <div className="relative z-20 container mx-auto px-4 py-12">
        <div
          ref={titleRef}
          className={`
            text-center mb-12 transform transition-all duration-700 ease-out
            ${isTitleVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          <h1 className="text-4xl font-bold text-white mb-6">Nasza Galeria</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Zobacz efekty naszej pracy i przekonaj się o jakości świadczonych usług
          </p>
        </div>

        {/* Siatka zdjęć */}
        <GalleryGrid
          images={galleryImages}
          onImageClick={(image) => {
            setSelectedImage(image);
          }}
        />

        {/* Modal ze zdjęciem */}
        {selectedImage && (
          <ImageModal
            currentImage={selectedImage}
            onClose={() => setSelectedImage(null)}
            onNext={handleNext}
            onPrevious={handlePrevious}
          />
        )}
      </div>
    </div>
  );
};

export default Gallery;